import { Autocomplete, AutocompleteChangeReason, MultiSelect, MultiSelectOptionType } from '@parspec/pixel';

import { FormFieldAction } from '../FormFieldAction';
import { RowContainer } from '../RowContainer';
import { DropdownOptionsType, DropdownOptionType } from '../../types';

interface SelectRowProps {
    options: DropdownOptionsType;
    selectedOptions: { values?: DropdownOptionsType | DropdownOptionType; locked: boolean; value?: string };
    onSelect: (value: DropdownOptionsType | string, reason?: AutocompleteChangeReason) => void;
    onLockChange: (isLocked: boolean) => void;
    label: string;
    id: string;
    onBlur: () => void;
    isLastRow?: boolean;
    error?: boolean;
    disableRow?: boolean;
    isSingleSelect?: boolean;
    rowTooltip?: string;
    sortOptions?: boolean;
}

export function SelectRow({
    onLockChange,
    label,
    options,
    selectedOptions,
    id,
    onSelect,
    onBlur,
    isLastRow = false,
    error,
    disableRow,
    isSingleSelect = false,
    rowTooltip,
    sortOptions = true
}: SelectRowProps) {
    function handleMultiSelect(_event: React.SyntheticEvent<Element, Event>, value: MultiSelectOptionType[], reason: AutocompleteChangeReason) {
        onSelect(value as DropdownOptionsType, reason);
    }

    function handleSingleSelect(event: React.SyntheticEvent & { target: { value: { label: string; value: string } | null } }) {
        onSelect(event.target.value?.value || '');
    }

    function getFilteredOptions(options: MultiSelectOptionType[], params: { inputValue: string }) {
        if (params.inputValue) {
            return options.filter((item) => String(item.value).toLowerCase().includes(params.inputValue.toLowerCase()));
        }
        return options;
    };

    return (
        <RowContainer isLastRow={isLastRow} rowTooltip={rowTooltip}>
            {isSingleSelect ? (
                <Autocomplete
                    label={label}
                    options={options}
                    value={selectedOptions.value || null}
                    onChange={handleSingleSelect}
                    optionlabelkeyname="label"
                    onBlur={onBlur}
                    disabled={disableRow}
                    blurOnEmptyInput={onBlur}
                    filterOptionsCallBack={getFilteredOptions}
                />
            ) : (
                <MultiSelect
                    id={id}
                    value={selectedOptions.values as DropdownOptionsType}
                    label={label}
                    options={options}
                    onChange={handleMultiSelect}
                    size="small"
                    limitTags={4}
                    multiple
                    onBlur={onBlur}
                    error={error}
                    disabled={disableRow}
                    shouldSortOptions={sortOptions}
                />
            )}
            <FormFieldAction isLocked={selectedOptions.locked} onLockChange={onLockChange} showClear={false} isDisabled={disableRow} tooltip="Strict matching" />
        </RowContainer>
    );
}
